var _defs, _rect, _rect2, _ellipse, _rect3, _text, _g, _rect4, _rect5, _path, _rect6, _path2, _circle, _circle2, _rect7, _text2, _rect8, _text3, _rect9, _text4, _rect10, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLpToken(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 290,
    height: 500,
    viewBox: "0 0 290 500",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "f1"
  }, /*#__PURE__*/React.createElement("feImage", {
    result: "p0",
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMjkwJyBoZWlnaHQ9JzUwMCcgdmlld0JveD0nMCAwIDI5MCA1MDAnIHhtbG5zPSdodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2Zyc+PHJlY3Qgd2lkdGg9JzI5MHB4JyBoZWlnaHQ9JzUwMHB4JyBmaWxsPScjZTgxYjZlJy8+PC9zdmc+"
  }), /*#__PURE__*/React.createElement("feImage", {
    result: "p1",
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMjkwJyBoZWlnaHQ9JzUwMCcgdmlld0JveD0nMCAwIDI5MCA1MDAnIHhtbG5zPSdodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2Zyc+PGNpcmNsZSBjeD0nMTA3JyBjeT0nNDE2JyByPScxMjBweCcgZmlsbD0nI2MwMmFhYScvPjwvc3ZnPg=="
  }), /*#__PURE__*/React.createElement("feImage", {
    result: "p2",
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMjkwJyBoZWlnaHQ9JzUwMCcgdmlld0JveD0nMCAwIDI5MCA1MDAnIHhtbG5zPSdodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2Zyc+PGNpcmNsZSBjeD0nMjEzJyBjeT0nMzcxJyByPScxMjBweCcgZmlsbD0nI2QwMGZmMCcvPjwvc3ZnPg=="
  }), /*#__PURE__*/React.createElement("feImage", {
    result: "p3",
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMjkwJyBoZWlnaHQ9JzUwMCcgdmlld0JveD0nMCAwIDI5MCA1MDAnIHhtbG5zPSdodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2Zyc+PGNpcmNsZSBjeD0nNjEnIGN5PSczNDgnIHI9JzEwMHB4JyBmaWxsPScjNzU2Y2MyJy8+PC9zdmc+"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in: "p0",
    in2: "p1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "exclusion",
    in2: "p2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "p3",
    result: "blendOut"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "blendOut",
    stdDeviation: 42
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "corners"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 290,
    height: 500,
    rx: 42,
    ry: 42
  })), /*#__PURE__*/React.createElement("path", {
    id: "text-path-a",
    d: "M40 12 H250 A28 28 0 0 1 278 40 V460 A28 28 0 0 1 250 488 H40 A28 28 0 0 1 12 460 V40 A28 28 0 0 1 40 12 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "minimap",
    d: "M234 444C234 457.949 242.21 463 253 463"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "top-region-blur"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 24
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad-up",
    x1: 1,
    x2: 0,
    y1: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "white",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad-down",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "white",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("mask", {
    id: "fade-up",
    maskContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    fill: "url(#grad-up)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "fade-down",
    maskContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    fill: "url(#grad-down)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "none",
    maskContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    fill: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad-symbol"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "white",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("mask", {
    id: "fade-symbol",
    maskContentUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "290px",
    height: "200px",
    fill: "url(#grad-symbol)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#corners)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "e81b6e",
    x: "0px",
    y: "0px",
    width: "290px",
    height: "500px"
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      filter: "url(#f1)"
    },
    x: "0px",
    y: "0px",
    width: "290px",
    height: "500px"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#top-region-blur)",
      transform: "scale(1.5)",
      transformOrigin: "center top"
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    x: "0px",
    y: "0px",
    width: "290px",
    height: "500px"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: "50%",
    cy: "0px",
    rx: "180px",
    ry: "120px",
    fill: "#000",
    opacity: 0.85
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 290,
    height: 500,
    rx: 42,
    ry: 42,
    fill: "rgba(0,0,0,0)",
    stroke: "rgba(255,255,255,0.2)"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    textRendering: "optimizeSpeed"
  }, /*#__PURE__*/React.createElement("textPath", {
    startOffset: "-100%",
    fill: "white",
    fontFamily: "'Courier New', monospace",
    fontSize: "10px",
    xlinkHref: "#text-path-a"
  }, "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2 \u2022 WETH ", /*#__PURE__*/React.createElement("animate", {
    additive: "sum",
    attributeName: "startOffset",
    from: "0%",
    to: "100%",
    begin: "0s",
    dur: "30s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("textPath", {
    startOffset: "0%",
    fill: "white",
    fontFamily: "'Courier New', monospace",
    fontSize: "10px",
    xlinkHref: "#text-path-a"
  }, "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2 \u2022 WETH ", /*#__PURE__*/React.createElement("animate", {
    additive: "sum",
    attributeName: "startOffset",
    from: "0%",
    to: "100%",
    begin: "0s",
    dur: "30s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("textPath", {
    startOffset: "50%",
    fill: "white",
    fontFamily: "'Courier New', monospace",
    fontSize: "10px",
    xlinkHref: "#text-path-a"
  }, "0xe81b6ef5ef04972d9d0548848024058b59d00ff0 \u2022 DEYE ", /*#__PURE__*/React.createElement("animate", {
    additive: "sum",
    attributeName: "startOffset",
    from: "0%",
    to: "100%",
    begin: "0s",
    dur: "30s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("textPath", {
    startOffset: "-50%",
    fill: "white",
    fontFamily: "'Courier New', monospace",
    fontSize: "10px",
    xlinkHref: "#text-path-a"
  }, "0xe81b6ef5ef04972d9d0548848024058b59d00ff0 \u2022 DEYE ", /*#__PURE__*/React.createElement("animate", {
    additive: "sum",
    attributeName: "startOffset",
    from: "0%",
    to: "100%",
    begin: "0s",
    dur: "30s",
    repeatCount: "indefinite"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#fade-symbol)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    x: "0px",
    y: "0px",
    width: "290px",
    height: "200px"
  }), /*#__PURE__*/React.createElement("text", {
    y: "70px",
    x: "32px",
    fill: "white",
    fontFamily: "'Courier New', monospace",
    fontWeight: 200,
    fontSize: "36px"
  }, "DEYE/WETH"), /*#__PURE__*/React.createElement("text", {
    y: "115px",
    x: "32px",
    fill: "white",
    fontFamily: "'Courier New', monospace",
    fontWeight: 200,
    fontSize: "36px"
  }, "0.3%"))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 258,
    height: 468,
    rx: 26,
    ry: 26,
    fill: "rgba(0,0,0,0)",
    stroke: "rgba(255,255,255,0.2)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#none)",
    style: {
      transform: "translate(72px,189px)"
    }
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: "-16px",
    y: "-16px",
    width: "180px",
    height: "180px",
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1C1 97 49 145 145 145",
    stroke: "rgba(0,0,0,0.3)",
    strokeWidth: "32px",
    fill: "none",
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#none)",
    style: {
      transform: "translate(72px,189px)"
    }
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: "-16px",
    y: "-16px",
    width: "180px",
    height: "180px",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 1C1 97 49 145 145 145",
    stroke: "rgba(255,255,255,1)",
    fill: "none",
    strokeLinecap: "round"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "73px",
    cy: "190px",
    r: "4px",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "217px",
    cy: "334px",
    r: "4px",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      transform: "translate(29px, 384px)"
    }
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: "98px",
    height: "26px",
    rx: "8px",
    ry: "8px",
    fill: "rgba(0,0,0,0.6)"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: "12px",
    y: "17px",
    fontFamily: "'Courier New', monospace",
    fontSize: "12px",
    fill: "white"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "rgba(255,255,255,0.6)"
  }, "ID: "), "229650"))), /*#__PURE__*/React.createElement("g", {
    style: {
      transform: "translate(29px, 414px)"
    }
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: "133px",
    height: "26px",
    rx: "8px",
    ry: "8px",
    fill: "rgba(0,0,0,0.6)"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: "12px",
    y: "17px",
    fontFamily: "'Courier New', monospace",
    fontSize: "12px",
    fill: "white"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "rgba(255,255,255,0.6)"
  }, "Min Tick: "), "58080"))), /*#__PURE__*/React.createElement("g", {
    style: {
      transform: "translate(29px, 444px)"
    }
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: "140px",
    height: "26px",
    rx: "8px",
    ry: "8px",
    fill: "rgba(0,0,0,0.6)"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: "12px",
    y: "17px",
    fontFamily: "'Courier New', monospace",
    fontSize: "12px",
    fill: "white"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "rgba(255,255,255,0.6)"
  }, "Max Tick: "), "230280"))), /*#__PURE__*/React.createElement("g", {
    style: {
      transform: "translate(226px, 433px)"
    }
  }, _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: "36px",
    height: "36px",
    rx: "8px",
    ry: "8px",
    fill: "none",
    stroke: "rgba(255,255,255,0.2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M8 9C8.00004 22.9494 16.2099 28 27 28",
    fill: "none",
    stroke: "white"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      transform: "translate3d(24px, 27px, 0px)"
    },
    cx: "0px",
    cy: "0px",
    r: "4px",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLpToken);
export default __webpack_public_path__ + "static/media/lp_token.7689b9fb7c230ed79e90025f54b864d7.svg";
export { ForwardRef as ReactComponent };